var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_16474_180868)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0303 20.9697C21.7374 20.6768 21.2625 20.6768 20.9696 20.9697C20.6767 21.2625 20.6767 21.7374 20.9696 22.0303L22.9393 24L20.9697 25.9697C20.6768 26.2625 20.6768 26.7374 20.9697 27.0303C21.2626 27.3232 21.7374 27.3232 22.0303 27.0303L24 25.0607L25.9696 27.0303C26.2625 27.3232 26.7374 27.3232 27.0303 27.0303C27.3232 26.7374 27.3232 26.2625 27.0303 25.9696L25.0606 24L27.0303 22.0303C27.3232 21.7374 27.3232 21.2626 27.0303 20.9697C26.7374 20.6768 26.2625 20.6768 25.9696 20.9697L24 22.9393L22.0303 20.9697Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.25C18.0629 13.25 13.25 18.0629 13.25 24C13.25 29.9371 18.0629 34.75 24 34.75C29.9371 34.75 34.75 29.9371 34.75 24C34.75 18.0629 29.9371 13.25 24 13.25ZM14.75 24C14.75 18.8914 18.8914 14.75 24 14.75C29.1086 14.75 33.25 18.8914 33.25 24C33.25 29.1086 29.1086 33.25 24 33.25C18.8914 33.25 14.75 29.1086 14.75 24Z",
    fill: "#F7F7F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16474_180868",
    x1: 18,
    y1: -4,
    x2: 30.5,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D61607"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/paymentError.686c3ad001b4ca81a9325d7fb18a3cce.svg";
export { ForwardRef as ReactComponent };